import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import MobileLayout from '@/layout/mobile'
import NotFound from '@/views/error/404.vue' // 确保 NotFound 也有 .vue

Vue.use(Router)

// 判断是否为移动端
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// --- 为每个视图定义懒加载组件 ---
const RedirectComponent = () => import('@/views/redirect')

const IndexMobileComponent = () => import('@/views/mobile/index')
const IndexDesktopComponent = () => import('@/views/index')

const ProductMobileComponent = () => import('@/views/mobile/product')
const ProductDesktopComponent = () => import('@/views/product')

const CaseMobileComponent = () => import('@/views/mobile/case')
const CaseDesktopComponent = () => import('@/views/custom') // 注意：PC端是 custom.vue

const IndustryMobileComponent = () => import('@/views/mobile/industry')
const IndustryDesktopComponent = () => import('@/views/industry')

const NewMobileComponent = () => import('@/views/mobile/new')
const NewDesktopComponent = () => import('@/views/new')

const NewsDetailMobileComponent = () => import('@/views/mobile/newsDetail')
const NewsDetailDesktopComponent = () => import('@/views/new/components/detail')

const AboutMobileComponent = () => import('@/views/mobile/about')
const AboutDesktopComponent = () => import('@/views/about')

const ContactMobileComponent = () => import('@/views/mobile/contact')
const ContactDesktopComponent = () => import('@/views/contact')
// --- 懒加载组件定义结束 ---

export const constantRoutes = [
  {
    path: '/redirect',
    component: isMobile() ? MobileLayout : Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: RedirectComponent
      }
    ]
  },
  {
    path: '',
    component: isMobile() ? MobileLayout : Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: isMobile() ? IndexMobileComponent : IndexDesktopComponent,
        meta: { title: '首页', affix: true }
      },
      {
        path: 'product',
        name: 'Product',
        component: isMobile() ? ProductMobileComponent : ProductDesktopComponent,
        meta: { title: '产品服务', affix: true },
      },
      {
        path: 'case',
        name: 'Case',
        component: isMobile() ? CaseMobileComponent : CaseDesktopComponent,
        meta: { title: '客户案例', affix: true },
      },
      {
        path: 'industry',
        name: 'Industry',
        component: isMobile() ? IndustryMobileComponent : IndustryDesktopComponent,
        meta: { title: '行业解决方案', affix: true },
      },
      {
        path: 'new',
        name: 'New',
        component: isMobile() ? NewMobileComponent : NewDesktopComponent,
        meta: { title: '新闻资讯', affix: true },
      },
      {
        path: 'newsDetail',
        name: 'NewsDetail',
        component: isMobile() ? NewsDetailMobileComponent : NewsDetailDesktopComponent,
        meta: { title: '新闻详情', affix: true },
      },
      {
        path: 'about',
        name: 'About',
        component: isMobile() ? AboutMobileComponent : AboutDesktopComponent,
        meta: { title: '关于我们', affix: true },
      },
      {
        path: '/contact', // 注意：此路径以 / 开头，通常表示绝对路径
        name: 'Contact',
        component: isMobile() ? ContactMobileComponent : ContactDesktopComponent,
        meta: { title: '联系我们', affix: true },
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: NotFound, // NotFound 也已确保 .vue
  },
];

// 防止连续点击多次路由报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

//创建并暴露一个路由器
export default new Router({
  // mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
